// extracted by mini-css-extract-plugin
export default {"switch":"tb_switch__14bUh","slider":"tb_slider__51-KX","round":"tb_round__-rfGC"};